import React from 'react'
import PropTypes from 'prop-types'
import StoreIcons from '../common/icons/StoreIcons'
import extractYotiHostEnv from '../../utils/extractYotiHostEnv'

// Note: this is the tracker for Yoti only
const STORE_LINK = 'https://app.adjust.com/12vy3clm_12pgjqq5'

function buildFullTrackerUrl(isMobile) {
  const campaignParts = [
    'device', isMobile ? 'mobile' : 'desktop',
    'env', extractYotiHostEnv(window.location.hostname),
    'page', 'learnmore'
  ]

  const trackerUrl = new URL(STORE_LINK)
  trackerUrl.searchParams.set('campaign', campaignParts.join('_'))
  return trackerUrl.toString()
}

const DeviceStoreIcons = ({ device: { type, operatingSystemName } }) => {
  const isMobile = type === 'mobile'
  const showAppStore = isMobile ? operatingSystemName === 'iOS' : true
  const showPlayStore = isMobile ? operatingSystemName === 'Android' : true
  return <StoreIcons storeLink={buildFullTrackerUrl(isMobile)} showAppStore={showAppStore} showPlayStore={showPlayStore} useTargetSelf={isMobile} />
}

DeviceStoreIcons.defaultProps = {
  device: {}
}

DeviceStoreIcons.propTypes = {
  device: PropTypes.shape({
    type: PropTypes.string,
    operatingSystemName: PropTypes.string
  })
}

export default DeviceStoreIcons
